(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velion-opt-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velion-direct-checkout')) {
    customElements.define('velion-direct-checkout', class VelionDirectCheckout extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-velion-checkout]');
        this.status = this.querySelector('[data-velion-checkout-status]');
        this.handleClick = this.checkout.bind(this);
        this.button?.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
      }

      findDeep(root, selector) {
        const match = root.querySelector?.(selector);
        if (match) return match;

        for (const element of root.querySelectorAll?.('*') || []) {
          if (!element.shadowRoot) continue;
          const shadowMatch = this.findDeep(element.shadowRoot, selector);
          if (shadowMatch) return shadowMatch;
        }

        return null;
      }

      async getBundleBlock() {
        for (let attempt = 0; attempt < 40; attempt += 1) {
          const block = this.findDeep(this, 'kaching-bundles-block');
          if (block && typeof block.items === 'function') return block;
          await new Promise((resolve) => setTimeout(resolve, 125));
        }

        return null;
      }

      showStatus(message, isError = false) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.hidden = false;
        this.status.classList.toggle('is-error', isError);
      }

      clearStatus() {
        if (!this.status) return;
        this.status.textContent = '';
        this.status.hidden = true;
        this.status.classList.remove('is-error');
      }

      async checkout() {
        if (!this.button || this.busy) return;

        this.busy = true;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.clearStatus();

        try {
          const block = await this.getBundleBlock();
          if (!block) throw new Error('Bitte wähle zuerst ein Angebot aus.');

          const selectedItems = block.items();
          if (!Array.isArray(selectedItems) || selectedItems.length === 0) {
            throw new Error('Bitte wähle zuerst ein Angebot aus.');
          }

          const items = selectedItems.map((item) => {
            const cartItem = {
              id: item.id,
              quantity: Number(item.quantity) || 1
            };

            if (item.properties) cartItem.properties = item.properties;
            if (item.selling_plan) cartItem.selling_plan = item.selling_plan;
            return cartItem;
          });

          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });

          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(result.description || 'Das Angebot konnte nicht hinzugefügt werden.');
          }

          window.location.assign(`${root}checkout`);
        } catch (error) {
          this.showStatus(error.message || 'Bitte versuche es noch einmal.', true);
          this.busy = false;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
